function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "108.356%",
  y1: "17.605%",
  x2: "42.488%",
  y2: "62.792%",
  id: "c"
}, React.createElement("stop", {
  stopColor: "#5320EE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5D28E2",
  offset: "32.604%"
}), React.createElement("stop", {
  stopColor: "#622BDD",
  offset: "100%"
})), React.createElement("path", {
  d: "M149.297 228.951V125.875L77.956 228.951h71.34zm130.87 63.359h-48.663v78.962h-82.207V292.31H0v-56.267L142.21 30.837h89.294v198.114h48.663v63.359zM585.847 202c0 99.766-44.41 174-138.43 174-98.743 0-138.902-73.76-138.902-174S351.98 28 447.417 28c94.02 0 138.43 74.234 138.43 174zM447.89 305.076c34.49 0 53.86-34.989 53.86-102.603S482.38 99.397 447.417 99.397c-34.961 0-54.805 35.462-54.805 103.076 0 67.614 20.788 102.603 55.278 102.603zm313.24-76.125V125.875l-71.342 103.076h71.341zM892 292.31h-48.663v78.962h-82.208V292.31H611.833v-56.267l142.21-205.206h89.294v198.114H892v63.359z",
  id: "b"
}), React.createElement("filter", {
  x: "-1.1%",
  y: "-2.3%",
  width: "102.2%",
  height: "105.7%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, React.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.325490196 0 0 0 0 0.125490196 0 0 0 0 0.933333333 0 0 0 0.2 0",
  "in": "shadowBlurOuter1"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#EEF4FF",
  d: "M177 0h651v397H177z"
}), React.createElement("g", {
  transform: "translate(6)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), React.createElement("use", {
  fill: "url(#c)",
  xlinkHref: "#b"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 904,
    height: 397,
    viewBox: "0 0 904 397",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/404.ded944f6.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/404/404.svg
// module id = 568
// module chunks = 0